/**
 * For custom checkboxes with the following html structure:
 *
 * <div class="custom-checkbox">
 *		<label><input type="checkbox" data-role="none" />Click me</label>
 * </div>

 span.checkbox-control holds the custom checkbox image. The image is used from the sprite in
 forms/ui/src/main/content/jcr_root/etc/designs/forms/clientlibs/desktop/css/base/form-sprites-generated.less

 .custom-checkbox label .checkbox-control {
	 background-image: url('@{imgPath}sprites/sprites-lores-1375968538552.png');
	 background-position: left -18px;
	 height: 13px;
	 width: 13px;
 }

 .custom-checkbox label.checked .checkbox-control {
	  background-image: url('@{imgPath}sprites/sprites-lores-1375968538552.png');
	 background-position: left -31px;
	 height: 13px;
	 width: 13px;
 }

 * Usage: $('input:checkbox').scsCustomCheckbox();
 * @author Thomas Junghans
 */
;(function ($, window, undefined ) {
	"use strict";

	var setCheckbox = function ($el) {
		var isChecked = $el.prop('checked'),
			$label = $el.parent('label');

		if ($el.is(':checkbox')) {
			if ($label.find('span.checkbox-control').length === 0) {
				$el.after('<span class="checkbox-control" role="checkbox" data-role="none"></span>');
			}

			$label.toggleClass('checked', isChecked).find('span.checkbox-control').attr('aria-checked', isChecked);
		}
	};

	$.fn.scsCustomCheckbox = function() {

		// Prevent text selection.
		// See also http://stackoverflow.com/questions/880512/prevent-text-selection-after-double-click
		this.each(function () {

			var $el = $(this);

			$el.parent('label').mousedown(function(){ return false; });

			setCheckbox($el);

		});

		this.change(function () {
			setCheckbox($(this));
		});

		return this;
	};
}(jQuery, window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/libraries/jquery.scs-custom-checkbox.js
// module id = 84
// module chunks = 0